import FleetUtils from '@/utils/fleet-utils/FleetUtils'

const redirectUri =
  process.env.REACT_APP_TESLA_POWERWALL_FLEET_REDIRECT_URI ??
  'https://optiwatt.com/tesla-authentication/energy-system'

export function useEnergySystemFleetAuthUrl() {
  const { url } = FleetUtils.useFleetAuthUrl('energy_system')
  return url
}
